var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-avatar',_vm._g(_vm._b({attrs:{"color":_vm.statusColor(_vm.vehicleStatusValue),"size":"20"}},'v-avatar',attrs,false),on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.vehicleStatusValue || 'Unknown'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }